import deleteIcon from '../../../assets/icons/delete-icon.svg';
import classes from './EditButton.module.css';

interface Props {
  onClick: () => void;
}

const DeleteButton: React.FC<Props> = ({ onClick }) => {
  return <img src={deleteIcon} className={classes.container} onClick={onClick} alt="delete" />;
};

export default DeleteButton;
